
import { RefObject } from "react";
import { FileTypeSelector } from "./components/FileTypeSelector";
import { CategorySelector } from "./components/CategorySelector";
import { FileInfoFields } from "./components/FileInfoFields";
import { VideoDurationField } from "./components/VideoDurationField";
import { PreviewImageField } from "./components/PreviewImageField";
import { FileUploadField } from "./components/FileUploadField";
import { FileNameField } from "./components/FileNameField";
import { UploadButton } from "./components/UploadButton";
import { FilePreview } from "./components/FilePreview";
import { FileCategory, NewFileState } from "./types";

interface FileUploadFormProps {
  newFile: NewFileState;
  onNewFileChange: (file: NewFileState) => void;
  onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddFile: () => void;
  fileInputRef: RefObject<HTMLInputElement>;
  videoInputRef: RefObject<HTMLInputElement>;
  fileCategories: FileCategory[];
}

export function FileUploadForm({
  newFile,
  onNewFileChange,
  onFileInputChange,
  onAddFile,
  fileInputRef,
  videoInputRef,
  fileCategories
}: FileUploadFormProps) {
  return (
    <div className="space-y-4">
      <FileTypeSelector 
        selectedType={newFile.type} 
        onChange={(type) => onNewFileChange({...newFile, type})}
      />
      
      <CategorySelector 
        value={newFile.category}
        onChange={(category) => onNewFileChange({...newFile, category})}
        categories={fileCategories}
      />
      
      <FileInfoFields 
        title={newFile.title || ''}
        description={newFile.description || ''}
        onTitleChange={(title) => onNewFileChange({...newFile, title})}
        onDescriptionChange={(description) => onNewFileChange({...newFile, description})}
      />
      
      {newFile.type === 'video' && (
        <VideoDurationField 
          value={newFile.duration || ''}
          onChange={(duration) => onNewFileChange({...newFile, duration})}
        />
      )}
      
      <PreviewImageField 
        previewImage={newFile.previewImage}
        onChange={(previewImage) => onNewFileChange({...newFile, previewImage})}
      />
      
      <FileUploadField 
        type={newFile.type}
        fileInputRef={fileInputRef}
        videoInputRef={videoInputRef}
        onChange={onFileInputChange}
      />
      
      <FileNameField
        value={newFile.name}
        onChange={(name) => onNewFileChange({...newFile, name})}
      />
      
      <UploadButton 
        onClick={onAddFile}
        disabled={!newFile.file || !newFile.category || !newFile.title}
      />
      
      {newFile.file && (
        <FilePreview
          file={newFile.file}
          category={newFile.category}
          title={newFile.title || ''}
          fileCategories={fileCategories}
        />
      )}
    </div>
  );
}
